import { Fragment, useState } from "react";
import { Transition } from "@headlessui/react";
import { Link } from 'react-router-dom';
import { ai4curbWhiteIcon, ai4curbTransparentIcon } from "../assets";

export default function NavigationHeader() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  // Menu items array to populate both desktop and mobile links
  const menuItems = [
    // {
    //   name: "Home",
    //   url: "/#",
    // }
    // {
    //   name: "Features",
    //   url: "/#",
    // },
    // {
    //   name: "About Us",
    //   url: "/#",
    // },
  ];

  return (
    <>
      {/* Main Header Section: Simple with Actions */}
      <div className="relative overflow-hidden bg-gray-900 dark:bg-gray-900 dark:text-gray-100">
        {/* Main Header */}
        <header
          id="page-header"
          className="relative flex flex-none items-center py-8"
        >
          {/* Main Header Content */}
          <div className="container mx-auto flex items-center justify-between px-4 text-center lg:px-8 xl:max-w-7xl">
            
            {/* Left Section */}
            <div className="flex items-center">
              {/* Logo */}
              <Link to="/#" className="group inline-flex items-center space-x-2 text-lg font-bold tracking-wide text-gray-900 hover:text-gray-600 dark:text-gray-100 dark:hover:text-gray-300">
                <img src={ai4curbWhiteIcon} alt="Ai4Curb" className="w-[100px] h-auto" />
              </Link>
              {/* END Logo */}
            </div>
            {/* END Left Section */}

            {/* Right Section */}
            <div className="flex items-center">
              {/* Navigation */}
              <nav className="hidden space-x-3 md:space-x-6 lg:block">
                {menuItems.map((item) => (
                  <Link key={item.name} to={item.url}>
                    <button type="button"
                      className="text-sm font-semibold text-white hover:text-primary-500 dark:text-gray-100 dark:hover:text-primary-400">
                      {item.name}
                    </button>
                  </Link>
                ))}
              </nav>
              {/* END Navigation */}

              {/* Divider */}
              <div className="mx-6 hidden h-8 w-px bg-gradient-to-b from-transparent via-gray-300 to-transparent lg:block dark:via-gray-700" />

              {/* Actions */}
              <div className="flex items-center justify-center gap-2">

                <Link to='/signin'>
                  <button type="button" 
                    className="inline-flex items-center justify-center space-x-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold leading-5 text-gray-800 hover:border-gray-300 hover:text-gray-900 hover:shadow-sm focus:ring focus:ring-gray-300 focus:ring-opacity-25 active:border-gray-200 active:shadow-none dark:border-gray-700 dark:bg-transparent dark:text-gray-300 dark:hover:border-gray-600 dark:hover:text-gray-200 dark:focus:ring-gray-600 dark:focus:ring-opacity-40 dark:active:border-gray-700" >
                    {/* className="inline-flex items-center justify-center space-x-2 rounded-lg border border-teal-700 bg-teal-700 px-7 py-3.5 font-semibold leading-6 text-white hover:border-teal-600 hover:bg-teal-600 hover:text-white focus:ring focus:ring-teal-400 focus:ring-opacity-50 active:border-teal-700 active:bg-teal-700 dark:focus:ring-teal-400 dark:focus:ring-opacity-90"> */}
                    {"Log In"}
                  </button>
                </Link>

                <Link to='/signup'>
                  <button type="button" 
                    // className="inline-flex items-center justify-center space-x-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold leading-5 text-gray-800 hover:border-gray-300 hover:text-gray-900 hover:shadow-sm focus:ring focus:ring-gray-300 focus:ring-opacity-25 active:border-gray-200 active:shadow-none dark:border-gray-700 dark:bg-transparent dark:text-gray-300 dark:hover:border-gray-600 dark:hover:text-gray-200 dark:focus:ring-gray-600 dark:focus:ring-opacity-40 dark:active:border-gray-700" >
                    className="inline-flex items-center justify-center space-x-2 rounded-lg border border-teal-700 bg-teal-700 px-3 py-2 text-sm font-semibold leading-6 text-white hover:border-teal-600 hover:bg-teal-600 hover:text-white focus:ring focus:ring-teal-400 focus:ring-opacity-50 active:border-teal-700 active:bg-teal-700 dark:focus:ring-teal-400 dark:focus:ring-opacity-90">
                    {"Sign Up"}
                    <svg
                      className="hi-mini hi-arrow-right hidden size-5 opacity-50 sm:inline-block"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </Link>
              </div>
              {/* END Actions */}

              {/* Open Mobile Navigation */}
              <div className="ml-3 lg:hidden">
                <button
                  onClick={() => setMobileNavOpen(true)}
                  type="button"
                  className="inline-flex items-center justify-center space-x-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold leading-5 text-gray-800 hover:border-gray-300 hover:text-gray-900 hover:shadow-sm focus:ring focus:ring-gray-300 focus:ring-opacity-25 active:border-gray-200 active:shadow-none dark:border-gray-700 dark:bg-transparent dark:text-gray-300 dark:hover:border-gray-600 dark:hover:text-gray-200 dark:focus:ring-gray-600 dark:focus:ring-opacity-40 dark:active:border-gray-700"
                  aria-controls="tkMobileNav"
                >
                  <svg
                    className="hi-mini hi-bars-3 inline-block size-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10zm0 5.25a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
              {/* END Open Mobile Navigation */}
            </div>
            {/* END Right Section */}
          </div>
          {/* END Main Header Content */}

          {/* Mobile Navigation */}
          <Transition
            as={Fragment}
            show={mobileNavOpen}
            enter="transition ease-out duration-200"
            enterFrom="opacity-050 translate-x-full"
            enterTo="opacity-100 translate-x-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-x-0"
            leaveTo="opacity-50 translate-x-full"
          >
            <nav
              id="tkMobileNav"
              className="fixed bottom-0 right-0 top-0 z-50 w-72 overflow-auto bg-white/95 shadow-lg lg:hidden dark:bg-gray-800/95"
              tabIndex={-1}
              aria-labelledby="tkMobileNavLabel"
              aria-modal="true"
              role="dialog"
            >
              <div className="flex items-center justify-between p-6">
                <Link to="/#" className="group inline-flex items-center space-x-2 text-lg font-bold tracking-wide text-gray-900 hover:text-gray-600 dark:text-gray-100 dark:hover:text-gray-300" >
                  <img src={ai4curbTransparentIcon} alt="Ai4Curb" className="hi-mini hi-cube-transparent inline-block size-5 text-primary-600 transition group-hover:scale-110 dark:text-primary-400" />
                  <span>Ai4Curb</span>
                </Link>

                {/* Close Mobile Navigation */}
                <button
                  onClick={() => setMobileNavOpen(false)}
                  type="button"
                  className="inline-flex items-center justify-center space-x-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold leading-5 text-gray-800 hover:border-gray-300 hover:text-gray-900 hover:shadow-sm focus:ring focus:ring-gray-300 focus:ring-opacity-25 active:border-gray-200 active:shadow-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:border-gray-600 dark:hover:text-gray-200 dark:focus:ring-gray-600 dark:focus:ring-opacity-40 dark:active:border-gray-700"
                >
                  <svg
                    className="hi-mini hi-x-mark -mx-0.5 inline-block size-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                  </svg>
                </button>
                {/* END Close Mobile Navigation */}
              </div>
              <div className="h-px bg-gray-200/75 dark:bg-gray-700/75" />
              <nav className="flex flex-col gap-2 px-6 py-5">
                {menuItems.map((item) => (
                  <a
                    key={item.name}
                    href={item.url}
                    className="py-1 text-sm font-semibold text-gray-900 hover:text-primary-600 dark:text-gray-100 dark:hover:text-primary-400"
                  >
                    <span>{item.name}</span>
                  </a>
                ))}
              </nav>
              <div className="h-px bg-gray-200/75 dark:bg-gray-700/75" />

              <div className="flex flex-col gap-2 p-6">
                <Link
                  to="/signin"
                  className="inline-flex items-center justify-center space-x-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold leading-5 text-gray-800 hover:border-gray-300 hover:text-gray-900 hover:shadow-sm focus:ring focus:ring-gray-300 focus:ring-opacity-25 active:border-gray-200 active:shadow-none dark:border-gray-700 dark:bg-transparent dark:text-gray-300 dark:hover:border-gray-600 dark:hover:text-gray-200 dark:focus:ring-gray-600 dark:focus:ring-opacity-40 dark:active:border-gray-700"
                >
                  <span>Log In</span>
                </Link>
                  
                <Link
                  to="/signup"
                  className="inline-flex items-center justify-center space-x-2 rounded-lg border border-teal-700 bg-teal-700 px-3 py-2 text-sm font-semibold leading-6 text-white hover:border-teal-600 hover:bg-teal-600 hover:text-white focus:ring focus:ring-teal-400 focus:ring-opacity-50 active:border-teal-700 active:bg-teal-700 dark:focus:ring-teal-400 dark:focus:ring-opacity-90"
                >
                  <span>Sign Up</span>
                </Link>
              </div>
            </nav>
          </Transition>
          {/* END Mobile Navigation */}

          {/* Mobile Navigation Backdrop */}
          <Transition
            as={Fragment}
            show={mobileNavOpen}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              onClick={() => setMobileNavOpen(false)}
              className="fixed inset-0 z-40 bg-gray-900 bg-opacity-20 backdrop-blur-sm will-change-auto lg:hidden dark:bg-opacity-80"
            />
          </Transition>
          {/* END Mobile Navigation Backdrop */}
        </header>
        {/* END Main Header */}
      </div>
      {/* END Main Header Section: Simple with Actions */}
    </>
  );
}
